import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter as Router } from "react-router-dom";
import { HOME_PAGE } from "./utils/config";
import { getTenantId } from "./utils/utils";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const id = getTenantId() || "default";
const baseName = `${HOME_PAGE}/${id}`.replace("//", "/");

root.render(
  <Router basename={baseName}>
    <App />
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
